import { createContext } from 'react';

import { IDecisionTemplateProps } from './DecisionTemplate';

export interface IDecisionTreeContext {
  decision: IDecisionTemplateProps | null;
  hasNext: boolean;
  hasPrevious: boolean;
  next: () => void;
  back: () => void;
  reset: () => void;
  goTo: (decisionId: string, skipHistory?: boolean) => void;
}

const contextDefault: IDecisionTreeContext = {
  decision: null,
  hasNext: false,
  hasPrevious: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  next: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  back: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  reset: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  goTo: (decisionId: string) => {}, // eslint-disable-line @typescript-eslint/no-unused-vars
};

export const DecisionTreeContext = createContext<IDecisionTreeContext>(contextDefault);
